/* tslint:disable */
/* eslint-disable */
/**
 * Property Search API
 * Search properties and get aggregated info about areas.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PropertySubTypeDto } from './PropertySubTypeDto';
import {
    PropertySubTypeDtoFromJSON,
    PropertySubTypeDtoFromJSONTyped,
    PropertySubTypeDtoToJSON,
    PropertySubTypeDtoToJSONTyped,
} from './PropertySubTypeDto';

/**
 * 
 * @export
 * @interface PropertyTypeDto
 */
export interface PropertyTypeDto {
    /**
     * 
     * @type {string}
     * @memberof PropertyTypeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyTypeDto
     */
    dealType: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyTypeDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyTypeDto
     */
    nameId: string;
    /**
     * 
     * @type {Array<PropertySubTypeDto>}
     * @memberof PropertyTypeDto
     */
    subTypes: Array<PropertySubTypeDto>;
}

/**
 * Check if a given object implements the PropertyTypeDto interface.
 */
export function instanceOfPropertyTypeDto(value: object): value is PropertyTypeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('dealType' in value) || value['dealType'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('nameId' in value) || value['nameId'] === undefined) return false;
    if (!('subTypes' in value) || value['subTypes'] === undefined) return false;
    return true;
}

export function PropertyTypeDtoFromJSON(json: any): PropertyTypeDto {
    return PropertyTypeDtoFromJSONTyped(json, false);
}

export function PropertyTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dealType': json['dealType'],
        'name': json['name'],
        'nameId': json['nameId'],
        'subTypes': ((json['subTypes'] as Array<any>).map(PropertySubTypeDtoFromJSON)),
    };
}

export function PropertyTypeDtoToJSON(json: any): PropertyTypeDto {
    return PropertyTypeDtoToJSONTyped(json, false);
}

export function PropertyTypeDtoToJSONTyped(value?: PropertyTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'dealType': value['dealType'],
        'name': value['name'],
        'nameId': value['nameId'],
        'subTypes': ((value['subTypes'] as Array<any>).map(PropertySubTypeDtoToJSON)),
    };
}

